// WhatMovedThisWeek — compact movement card row between KPI strip and the
// Market Signals board. Powered by `useMarketTracks.movementCards` (latest
// indexed week's signal rows).

import React from "react";

const KIND_TONE = {
    strengthening: "border-[hsl(var(--positive))] bg-[hsl(var(--positive-soft))]",
    softening: "border-[hsl(var(--negative))] bg-[hsl(var(--negative-soft))]",
    breadth: "border-[hsl(var(--accent))] bg-[hsl(var(--accent-soft))]",
    "actor-types": "border-[hsl(var(--line))] bg-[hsl(var(--surface-raised))]",
    exposure: "border-[hsl(var(--line))] bg-[hsl(var(--surface-raised))]",
    regulatory: "border-[hsl(var(--regulatory))] bg-[hsl(var(--regulatory-soft))]",
};

const KIND_GLYPH = {
    strengthening: "▲",
    softening: "▼",
    breadth: "↗",
    "actor-types": "●",
    exposure: "◆",
    regulatory: "§",
};

const WhatMovedThisWeek = ({ cards, weekLabel, onSelectTrack }) => {
    if (!cards || cards.length === 0) return null;
    return (
        <section data-testid="what-moved" className="space-y-3">
            <div>
                <div className="eyebrow">What moved this week</div>
                <div className="flex items-baseline gap-3 flex-wrap">
                    <h2 className="display text-xl">Weekly movement inside durable market signals</h2>
                    {weekLabel && <span className="text-[11px] text-[hsl(var(--mute))] num">{weekLabel}</span>}
                </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {cards.map((c, i) => (
                    <button
                        key={i}
                        type="button"
                        data-testid={`movement-card-${c.kind}`}
                        onClick={() => c.trackId && onSelectTrack && onSelectTrack(c.trackId)}
                        title={c.narrative || c.signalName}
                        className={`text-left p-3 rounded border ${KIND_TONE[c.kind] || "border-[hsl(var(--line))] bg-[hsl(var(--surface-raised))]"} hover:border-[hsl(var(--accent))] transition-colors`}
                    >
                        <div className="flex items-center gap-2 text-[10px] uppercase tracking-wider font-medium text-[hsl(var(--mute))]">
                            <span aria-hidden>{KIND_GLYPH[c.kind] || "·"}</span>
                            <span>{c.headline}</span>
                            <span className="ml-auto text-[hsl(var(--ink-soft))] num normal-case tracking-normal">{c.metric}</span>
                        </div>
                        <div className="mt-1.5 text-sm font-semibold text-[hsl(var(--ink))] leading-snug line-clamp-2">{c.signalName}</div>
                        {c.narrative && (
                            <div className="mt-1.5 text-[11px] text-[hsl(var(--ink-soft))] leading-relaxed line-clamp-2">{c.narrative}</div>
                        )}
                    </button>
                ))}
            </div>
        </section>
    );
};

export default WhatMovedThisWeek;
